import httpClient from "../http/http-client";
import { IReportPeriodWebpageSetting } from './report-period-webpage-setting.model';

export default class ReportPeriodWebpageSettingService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getReportPeriodWebpageSettings(reportPeriodId: string): Promise<IReportPeriodWebpageSetting> {
    return this.http.get(`report-period-webpage-setting/${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async saveCoverImage(reportPeriodId: string, details: any): Promise<IReportPeriodWebpageSetting> {
    return this.http.post(`report-period-webpage-setting/${reportPeriodId}/cover-image`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async updateSettings(reportPeriodId: string, settings: Partial<IReportPeriodWebpageSetting>): Promise<IReportPeriodWebpageSetting> {
    return this.http.patch(`report-period-webpage-setting/${reportPeriodId}`, settings)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
} 